<template>
	<Swiper v-bind="mainSwiperOptions">
		<SwiperSlide
			v-for="(item, idx) in props.data"
			:key="idx"
			@click="
				clickBanner(
					item.banner_url ?? item.hot_ranking_banner_image_pc_path ?? ''
					// item.banner_mo_url ?? item.hot_ranking_banner_image_mo_path ?? ''
				)
			"
		>
			<img
				:src="
					item.banner_image_url ??
					(displayStore.isExtraSmallScreen
						? item.hot_ranking_banner_image_pc_path
						: item.hot_ranking_banner_image_mo_path) ??
					''
				"
				:class="{ thin: props.thin }"
				:alt="`img${idx}`"
			/>
		</SwiperSlide>
		<div class="swiper-pagination"></div>
	</Swiper>
</template>

<script setup lang="ts">
//swiper
import { useRouter } from 'vue-router';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { banner_bottom } from '@/api/home';
import { useDisplayStore } from '@/stores/display';

const props = defineProps<{
	data: banner_bottom[];
	thin?: boolean;
}>();

const router = useRouter();

const displayStore = useDisplayStore();

// 슬라이드 옵션들
const mainSwiperOptions = {
	autoplay: {
		delay: 4500,
		disableOnInteraction: false,
	},
	modules: [Pagination, Autoplay, Navigation],
	pagination: {
		el: '.swiper-pagination',
		type: 'fraction',
		formatFractionCurrent: function (number: number) {
			return ('0' + number).slice(-2);
		},
		formatFractionTotal: function (number: number) {
			return ('0' + number).slice(-2);
		},
		renderFraction: (currentClass: string, totalClass: string) => {
			return (
				'<div class="swiper_wrapper"><div class="swiper_list"><div class="swiper-button-prev"></div><span class="' +
				currentClass +
				'"></span>' +
				'<span class="swiper-pagination-line">' +
				' | ' +
				'</span>' +
				'<span class="' +
				totalClass +
				'"></span><div class="swiper-button-next"></div></div>'
			);
		},
		clickable: true,
	},
	observer: true, // 추가
	observeParents: true, // 추가
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	loop: true,
};

const clickBanner = (url: string) => {
	const formatUrl = url.replace('https://www.masterpick.co.kr', '');
	router.push(formatUrl);

	// let agent = navigator.userAgent.toLowerCase();
	// if (agent.indexOf('android') !== -1 && window.masterpick) {
	// 	// window.masterpick.nativeUrlOpenBrowser(moUrl);
	// 	window.location.href = url;
	// } else if (
	// 	(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
	// 	window.webkit &&
	// 	window.webkit.messageHandlers &&
	// 	window.webkit.messageHandlers.nativeUrlOpenBrowser
	// ) {
	// 	console.log(moUrl);
	// 	// window.webkit.messageHandlers.nativeUrlOpenBrowser.postMessage(moUrl);
	// 	window.location.href = url;
	// } else {
	// 	window.open(url, '_self');
	// }
};
</script>

<style lang="scss" scoped>
.swiper {
	height: fit-content;
	overflow-y: visible;
	.swiper-slide > img {
		cursor: pointer;
		width: 100%;
		object-fit: fill;
		object-position: center;
		border-radius: var(--border-radius-small);
		height: 18rem;
		@media screen and (max-width: 600px) {
			height: 12rem;
		}
		&.thin {
			height: 10rem;
			@media screen and (max-width: 600px) {
				height: 6.5rem;
			}
		}
	}
	:deep(.swiper-pagination) {
		width: 100%;
		font-weight: var(--font-w-regular);
		font-size: var(--font-s-small);
		color: #fff;
		bottom: 0rem;
		position: unset;
		padding-top: 1rem;
		.swiper_wrapper {
			display: flex;
			justify-content: flex-end;
			max-width: 128rem;
			margin: 0 auto;
			.swiper_list {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 1rem;
				height: 2.6rem;
				width: 12.2rem;
				background-color: rgba(0, 0, 0, 0.6);
				border-radius: 10rem;
			}
			.swiper-pagination-line {
				color: var(--color-base-mid);
			}
			.swiper-pagination-current {
				font-size: var(--font-s-small);
				font-weight: var(--font-w-light);
				line-height: 1.551rem;
			}
			.swiper-pagination-total {
				color: var(--color-base-light);
				font-size: var(--font-s-small);
				font-weight: var(--font-w-light);
				line-height: 1.551rem;
			}
			.swiper-button-prev {
				position: unset;
				margin-top: 0;
				height: inherit;
				width: 2.2rem;
			}
			.swiper-button-next {
				position: unset;
				margin-top: 0;
				height: inherit;
				width: 2.2rem;
			}
			.swiper-button-prev::after {
				color: var(--color-base-white);
				font-size: var(--font-s-small);
				font-weight: var(--font-w-light);
				line-height: 1.551rem;
			}
			.swiper-button-next::after {
				color: var(--color-base-white);
				font-size: var(--font-s-small);
				font-weight: var(--font-w-light);
				line-height: 1.551rem;
			}
		}
	}
}
</style>
